// crewbit-admin/src/pages/Money/Tax.tsx
//
// Page wrapper for /money/tax. Mirrors the Expenses.tsx shape — heavy lifting
// lives in MoneyTaxAdmin. RequiresActiveBusinessGate is applied at the route
// level in App.tsx.

import { MoneyTaxAdmin } from '../../components/money/MoneyTaxAdmin';

export function MoneyTaxPage() {
  return <MoneyTaxAdmin />;
}
